import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';

import {
  canCloneInventoryListTemplateParams,
  canCreateInventoryListTemplate,
  canDeleteInventoryListTemplate,
  canEditInventoryListTemplate,
} from '@selectors/actions/inventoryListTemplateActions';

const getGlobalActions = ({
  authorizedActions,
  goToCreateILT,
  selectedILTs,
  handleCopyParamModal,
  handleDeletion,
  handleExport,
  handleAddReferences,
}) => {
  const selectedItemsCount = selectedILTs.length;

  const canCreate = canCreateInventoryListTemplate(authorizedActions);

  return [
    {
      id: 'create',
      actionLabel: i18next.t('GENERAL.CREATE'),
      fixed: canCreate,
      handleAction: goToCreateILT,
      isHidden: () => !canCreate,
      render: () => (
        <Button
          handleClick={goToCreateILT}
          icon={'/images/inpulse/add-white-small.svg'}
          label={i18next.t('GENERAL.CREATE')}
        />
      ),
    },
    {
      id: 'action-copy-param',
      actionLabel: i18next.t(
        'ADMIN.INVENTORY_LIST_TEMPLATES.COPY_INVENTORY_LIST_TEMPLATE_PARAMS_ACTION',
      ),
      actionIcon: () => '/images/inpulse/gear-ipblack-small.svg',
      handleAction: () => handleCopyParamModal(),
      isHidden: () =>
        !selectedItemsCount || !canCloneInventoryListTemplateParams(authorizedActions),
    },
    {
      id: 'action-add-references',
      actionLabel: i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.ADD_REFERENCES_PARAMS_ACTION'),
      actionIcon: () => '/images/inpulse/add-black-small.svg',
      handleAction: handleAddReferences,
      isHidden: () => !selectedItemsCount || !canEditInventoryListTemplate(authorizedActions),
    },
    {
      id: 'action-delete',
      actionLabel: i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_DELETE_ACTION', {
        count: selectedItemsCount,
      }),
      actionIcon: () => '/images/inpulse/delete-ip-black-small.svg',
      handleAction: async (items) => handleDeletion(items),
      isHidden: () => !selectedItemsCount || !canDeleteInventoryListTemplate(authorizedActions),
    },
    {
      id: 'export-list',
      actionLabel: i18next.t(
        selectedItemsCount ? 'GENERAL.EXPORT_SELECTION' : 'GENERAL.EXPORT_LIST',
      ),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: handleExport,
    },
  ];
};

const getRowActions = ({ handleDeletion, authorizedActions }) => [
  {
    id: 'action-delete',
    actionLabel: () =>
      i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_DELETE_ACTION', {
        count: 1,
      }),
    actionIcon: () => '/images/inpulse/delete-ip-black-small.svg',
    handleAction: (item) => handleDeletion([item]),
    isHidden: () => !canDeleteInventoryListTemplate(authorizedActions),
  },
];

const getInventoryListTemplateGlobalActions = ({
  isLoading,
  selectedItems,
  handleAddAssociation,
  handleRemoveAssociation,
  isRecipeAssociation = false,
  authorizedActions,
}) => {
  const hasSelectedItems = !!selectedItems.length;

  const canEditILTMappings = canEditInventoryListTemplate(authorizedActions);

  const actionsList = [
    {
      fixed: canEditILTMappings,
      id: 'action-add',
      actionLabel: i18next.t('GENERAL.ADD'),
      isHidden: () => !canEditILTMappings,
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={handleAddAssociation}
          icon="/images/inpulse/add-white-small.svg"
          isDisabled={isLoading}
          label={i18next.t('GENERAL.ADD')}
        />
      ),
      handleAction: () => {},
    },
  ];

  if (hasSelectedItems && canEditILTMappings) {
    actionsList.push({
      id: 'action-delete',
      actionLabel: i18next.t(
        isRecipeAssociation
          ? 'ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_REMOVE_RECIPE_ASSOCIATION'
          : 'ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_REMOVE_ASSOCIATION',
        {
          count: selectedItems.length,
        },
      ),
      actionIcon: () => '/images/inpulse/remove-black-small.svg',
      handleAction: handleRemoveAssociation,
    });
  }

  return actionsList;
};

const getInventoryListTemplateRowActions = ({
  handleRemoveAssociation,
  isRecipeAssociation = false,
  authorizedActions,
}) => [
  {
    id: 'delete',
    actionLabel: () =>
      i18next.t(
        isRecipeAssociation
          ? 'ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_REMOVE_RECIPE_ASSOCIATION'
          : 'ADMIN.INVENTORY_LIST_TEMPLATES.LABEL_REMOVE_ASSOCIATION',
        {
          count: 1,
        },
      ),
    actionIcon: () => '/images/inpulse/remove-black-small.svg',
    isHidden: () => !canEditInventoryListTemplate(authorizedActions),
    handleAction: (item) => handleRemoveAssociation([item]),
  },
];

export default {
  getGlobalActions,
  getRowActions,
  getInventoryListTemplateGlobalActions,
  getInventoryListTemplateRowActions,
};
